import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCwllYz_2B4FDB441zthF0L4F3FIaNKEow",
    authDomain: "clone-610e8.firebaseapp.com",
    databaseURL: "https://clone-610e8.firebaseio.com",
    projectId: "clone-610e8",
    storageBucket: "clone-610e8.appspot.com",
    messagingSenderId: "378798459504",
    appId: "1:378798459504:web:6d51c10c0f321e80eec2b5",
    measurementId: "G-SCJD1BRS4C"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };